import React from "react";

export function useDocumentTitle(title: string) {
	React.useEffect(() => {
		const oldTitle = document.title;
		document.title = `${title} | ${oldTitle}`;
		return () => void (document.title = oldTitle);
	}, [title]);
}

export default function DocumentTitle({ title, children }: React.PropsWithChildren<{ title: string }>) {
	useDocumentTitle(title);

	return <>{children}</>;
}
